import { State } from '@autopylot-internal/state';
import { FleetManagementState } from './FleetManagementState.ts';
import { NotesClient } from '../notes/NotesClient.ts';
import { AlertPresenter } from '../app/AlertBinder.tsx';
import { NoteValidator } from '../notes/NoteValidator.ts';
import { AircraftResponse } from './FleetManagmentClient.ts';
import { NotesModel } from '../notes/NotesModel.ts';
import { IAircraftNoteResponse } from './IAircraftNote.ts';

export class AircraftNotesModelFactory extends State<Record<string, never>> {
    static inject = () => [
        FleetManagementState,
        NotesClient,
        AlertPresenter,
        NoteValidator,
    ];
    constructor(
        private fleetState: FleetManagementState,
        private notesClient: NotesClient,
        private alert: AlertPresenter,
        private validator: NoteValidator,
    ) {
        super({});
    }

    private modelCache: { [aircraftId: string]: NotesModel<AircraftResponse, IAircraftNoteResponse> } = {};

    forAircraft = (aircraftId: string): NotesModel<AircraftResponse, IAircraftNoteResponse> => {
        if (!this.modelCache[aircraftId]) {
            const aircraft = this.fleetState.getAircraft(aircraftId);

            const model = new NotesModel<AircraftResponse, IAircraftNoteResponse>(aircraft!, this.notesClient, this.validator);

            model.load().catch(err => {
                this.alert.showAndLogError(err);
            });

            // we might be called from a render so avoid doing anything sync that might change state
            setTimeout(() => {
                // if the model changes, we change, that way components can just subscrive to the factory
                model.subscribe(() => {
                    this.setState({});
                });
            });

            this.modelCache[aircraftId] = model;
        }

        return this.modelCache[aircraftId];
    };
}
